import { markRaw, reactive } from 'vue'
import { detectPwaEnvironment, recordPwaInstalled, requestInstallPrompt } from './utils/pwaAccess.mjs'

const limitedAccessKey = 'iranibank:pwa-limited-public-access'

export const pwaInstallState = reactive({
  ...detectPwaEnvironment(window),
  limitedAccess: false,
  deferredPrompt: null,
  installing: false,
  installCompleted: false,
  manualRequested: false,
  message: '',
  error: ''
})

let monitoringStarted = false

export function refreshPwaEnvironment () {
  Object.assign(pwaInstallState, detectPwaEnvironment(window))
}

export function enableLimitedAccess () {
  pwaInstallState.limitedAccess = true
  try {
    sessionStorage.setItem(limitedAccessKey, '1')
  } catch (_) {
    // Still allow public pages for this document when storage is unavailable.
  }
}

export function startPwaInstallMonitoring () {
  if (monitoringStarted) return
  monitoringStarted = true
  try {
    pwaInstallState.limitedAccess = sessionStorage.getItem(limitedAccessKey) === '1'
  } catch (_) {
    pwaInstallState.limitedAccess = false
  }
  refreshPwaEnvironment()

  // Capture before routing/mounting, including while a public page is open.
  window.addEventListener('beforeinstallprompt', event => {
    if (!pwaInstallState.requiresInstall) return
    event.preventDefault()
    pwaInstallState.deferredPrompt = markRaw(event)
    pwaInstallState.installCompleted = false
    pwaInstallState.error = ''
    pwaInstallState.message = ''
  })
  window.addEventListener('appinstalled', () => {
    recordPwaInstalled(pwaInstallState)
    refreshPwaEnvironment()
  })
  window.addEventListener('pageshow', refreshPwaEnvironment)
  window.addEventListener('focus', refreshPwaEnvironment)
  document.addEventListener('visibilitychange', refreshPwaEnvironment)
  const displayMode = window.matchMedia('(display-mode: standalone)')
  if (displayMode.addEventListener) displayMode.addEventListener('change', refreshPwaEnvironment)
  else if (displayMode.addListener) displayMode.addListener(refreshPwaEnvironment)
}

export function requestPwaInstallation () {
  return requestInstallPrompt(pwaInstallState, refreshPwaEnvironment)
}
